import { Component } from 'react';
import { connect } from 'react-redux';
import { RouteConstants } from "../route/services/RouteConstants";
import { getLanguage } from "../../store/rootReducer";
import HrbTranslate from '../language/HrbTranslate';
import logo from '../../assets/images/hrb-logo-horizontal.svg';
import dict from '../../resources/data/dict.json';
import './UpdateEmailNew.scss';
import api from '../../services/api/AccountUpdateApi';
import { ErrorCodes } from '../../configurations/ErrorConstants';
import ValidationService from '../registration/services/ValidationService';
import { HeapEvents, trackEvent } from '../../services/util/AnalyticsUtil';

class UpdateEmailNew extends Component {

  constructor(props) {
    super(props);
    this.state = {
        errorMessage: null,
        newEmail: '',
        confirmEmail: '',
        isSubmitting: false,
        newEmailError: false,
        confirmEmailError: false,
        newEmailFieldError: null,
        confirmEmailFieldError: null
    };
  }

  componentDidMount() {
    if (!this.props.location.state || !this.props.location.state.username) {
      this.props.history.push(RouteConstants.UPDATE_EMAIL);
    }
  }

  handleNewEmailChange = (e) => {
    this.setState({ 
      newEmail: e.target.value,
      newEmailError: false,
      newEmailFieldError: null,
      errorMessage: null
    });
  };

  handleNewEmailBlur = () => {
    this.setState({ 
      newEmailError: false,
      newEmailFieldError: null,
      errorMessage: null
    });
  };

  handleConfirmEmailChange = (e) => {
    this.setState({ 
      confirmEmail: e.target.value,
      confirmEmailError: false,
      confirmEmailFieldError: null,
      errorMessage: null
    });
  };

  handleConfirmEmailBlur = () => {
    this.setState({ 
      confirmEmailError: false,
      confirmEmailFieldError: null,
      errorMessage: null
    });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    this.submitNewEmailForm();
  };

  submitNewEmailForm = async () => {
    this.setState({ 
      isSubmitting: false,
      newEmailError: false,
      confirmEmailError: false,
      errorMessage: null,
      newEmailFieldError: null,
      confirmEmailFieldError: null
    });

    const { newEmail, confirmEmail } = this.state;
    const { username, token } = this.props.location.state;

    const isNewEmailEmpty = !newEmail || newEmail.trim() === '';
    const isConfirmEmailEmpty = !confirmEmail || confirmEmail.trim() === '';
    const isNewEmailInvalid = !isNewEmailEmpty && !ValidationService.isValidEmail(newEmail, true);
    const isConfirmEmailInvalid = !isConfirmEmailEmpty && !ValidationService.isValidEmail(confirmEmail, true);

    if (isNewEmailInvalid && isConfirmEmailInvalid) {
      this.setState({ 
        newEmailError: true,
        confirmEmailError: true,
        newEmailFieldError: 'error_email_invalid_format',
        confirmEmailFieldError: 'error_email_invalid_format'
      });
      return;
    }

    if (isNewEmailInvalid && !isConfirmEmailInvalid) {
      this.setState({ 
        newEmailError: true,
        newEmailFieldError: 'error_email_invalid_format'
      });
      return;
    }

    if (!isNewEmailInvalid && isConfirmEmailInvalid) {
      this.setState({ 
        confirmEmailError: true,
        confirmEmailFieldError: 'error_email_invalid_format'
      });
      return;
    }

    if (isNewEmailEmpty || isConfirmEmailEmpty || newEmail !== confirmEmail) {
      this.setState({ 
        newEmailError: isNewEmailEmpty || newEmail !== confirmEmail,
        confirmEmailError: isConfirmEmailEmpty || newEmail !== confirmEmail,
        errorMessage: 'error_emails_mismatch_or_blank'
      });
      return;
    }

    trackEvent(HeapEvents.ACCONT_RECOVERY_UPDATED_EMAIL);

    this.setState({ isSubmitting: true });

    const response = await api.updateEmailAsync(newEmail, token);

    if (!response.success) {
      if (response.errorCode === ErrorCodes.UPDATE_FAILED) {
        this.props.history.push({
          pathname: RouteConstants.UPDATE_EMAIL_COMPLETE,
          state: { email: newEmail, emailExists: true }
        });
      } else {
        this.setState({ 
          newEmailError: 'Failed to update email. Please try again.',
          isSubmitting: false 
        });
      }
      return;
    }

    trackEvent(HeapEvents.ACCONT_RECOVERY_UPDATE_EMAIL_COMPLETE);

    this.props.history.push({
      pathname: RouteConstants.UPDATE_EMAIL_COMPLETE,
      state: { newEmail }
    });
  };

  render() {
    const { language } = this.props;
    
    return (
      <div className="hrb-update-email-new-card">
        <div className="hrb-update-email-new-logo">
          <img src={logo} alt="H&R Block" />
        </div>

        <h1 className="hrb-update-email-new-title">
          <HrbTranslate text="update_email.new.mobile_title" />
        </h1>

        <p className="hrb-update-email-new-intro">
          <HrbTranslate text="update_email.new.intro" />
        </p>

        <div className="hrb-update-email-new-form">
          <div className="hrb-update-email-new-input-wrapper-container">
            <div className={`hrb-update-email-new-input-wrapper ${this.state.newEmailError ? 'error' : ''}`}>
              <input
                type="email"
                className="hrb-update-email-new-input"
                placeholder={dict.update_email.new.new_email_field_label[language.toLowerCase()]}
                value={this.state.newEmail}
                onChange={this.handleNewEmailChange}
                onBlur={this.handleNewEmailBlur}
              />
            </div>
            {this.state.newEmailFieldError && (
              <div className="hrb-update-email-new-field-error">
                <HrbTranslate text={`update_email.new.${this.state.newEmailFieldError}`} />
              </div>
            )}
          </div>

          <div className="hrb-update-email-new-input-wrapper-container">
            <div className={`hrb-update-email-new-input-wrapper ${this.state.confirmEmailError ? 'error' : ''}`}>
              <input
                type="email"
                className="hrb-update-email-new-input"
                placeholder={dict.update_email.new.confirm_email_field_label[language.toLowerCase()]}
                value={this.state.confirmEmail}
                onChange={this.handleConfirmEmailChange}
                onBlur={this.handleConfirmEmailBlur}
              />
            </div>
            {this.state.confirmEmailFieldError && (
              <div className="hrb-update-email-new-field-error">
                <HrbTranslate text={`update_email.new.${this.state.confirmEmailFieldError}`} />
              </div>
            )}
          </div>

          {this.state.errorMessage && (
            <div className="hrb-update-email-new-error">
              <HrbTranslate text={`update_email.new.${this.state.errorMessage}`} />
            </div>
          )}
        </div>

        <div className="hrb-update-email-new-actions">
          <button
            className="hrb-update-email-new-button"
            onClick={this.submitNewEmailForm}
            disabled={this.state.isSubmitting}
          >
            <HrbTranslate text="update_email.new.update_email_button" />
          </button>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    language: getLanguage(state)
  };
};

export default connect(mapStateToProps)(UpdateEmailNew);
